import { library } from '@fortawesome/fontawesome-svg-core';

export const Icons = {
    setup: (...icons) => {
        return library.add(icons);
    },
};

export default Icons;
